import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Spinner, Text } from '@cochlear-design-system/foundation';
import {
  routes,
  cochlearLearningCentreAcademyURL,
} from '../../config';
import { setIdpParam } from '../../utils/authprovider';
import { getLabelsForFields } from '../../utils/labelHelper';

const Resources = ({ rendering }) => {
  const labels = getLabelsForFields(rendering.fields);

  const [showResource, setShowResource] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);

  const iframe = useRef();
  const { region } = useSelector(
    (state) => state.countryConfig.value,
  );

  let resourcesUrl = routes.mcp.resources;

  if (['EMEA', 'APAC'].includes(region)) {
    resourcesUrl = null;
  } else {
    resourcesUrl = resourcesUrl.replace('[REGION]', 'mcp-cam');
  }
  useEffect(() => {
    if (['EMEA', 'APAC'].includes(region)) {
      setShowSpinner(false);
    }
  }, [region]);

  useEffect(() => {
    const handleMessage = (e) => {
      if (e.origin !== routes.mcp.domain) return;
      if (typeof e.data === 'object') {
        if ('pageEvent' in e.data) {
          const mcpPageHeight = e.data.pageEvent.payload?.height;
          switch (e.data.pageEvent.type) {
            case 'pageLoaded':
              if (e.data.pageEvent.target === 'resources') {
                setShowSpinner(false);
                setShowResource(true);
                iframe.current.style.height =
                  mcpPageHeight === 0
                    ? '1000px'
                    : `${mcpPageHeight}px`;
              }
              break;
            default:
              break;
          }
        }
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div>
      {showSpinner && (
        <div className="spinner">
          <Spinner animation="border" />
        </div>
      )}
      {resourcesUrl ? (
        <iframe
          ref={iframe}
          src={setIdpParam(resourcesUrl)}
          id="resources-iframe"
          title="resources"
          width="100%"
          style={{
            visibility: showResource ? 'visible' : 'hidden',
          }}
        />
      ) : (
        <div className="ccl__container" style={{ marginTop: '30px' }}>
          <a
            href={cochlearLearningCentreAcademyURL}
            target="_blank"
            aria-label={
              labels['labels.common.cochlearLearningCentre']
            }
            rel="noreferrer"
          >
            <Text
              content={labels['labels.common.cochlearLearningCentre']}
              type="link-small-text"
            />
          </a>
        </div>
      )}
    </div>
  );
};

export default Resources;
